/**
 * @generated SignedSource<<2aa9e37dae539d79e20bab147e5c1d65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent$data = {
  readonly agentStudio_getAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"listItem_AtlassianConversationAssistantAgent_AgentListItem">;
      } | null;
    }>;
  } | null;
  readonly " $fragmentType": "paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent";
};
export type paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent$key = {
  readonly " $data"?: paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent">;
};

import paginatedAgentsListPaginationQuery_graphql from './paginatedAgentsListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "agentStudio_getAgents"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "product"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": paginatedAgentsListPaginationQuery_graphql
    }
  },
  "name": "paginatedAgentsList_AtlassianConversationAssistantAgent_PaginatedAgentsListContent",
  "selections": [
    {
      "alias": "agentStudio_getAgents",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        },
        {
          "kind": "Variable",
          "name": "product",
          "variableName": "product"
        }
      ],
      "concreteType": "AgentStudioAgentsConnection",
      "kind": "LinkedField",
      "name": "__paginatedAgentsList_agentStudio_getAgents_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "AgentStudioAgentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "AgentStudioAssistant",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "listItem_AtlassianConversationAssistantAgent_AgentListItem"
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "cbdada487b2af87d1123d213bee7d99e";

export default node;
